import { NgModule } from '@angular/core';
import { Base64Pipe } from '../pipes/base64.pipe';

@NgModule({
  declarations: [
    Base64Pipe,
  ],
  exports: [
    Base64Pipe,
  ],
})
export class PipesModule { }
